<template>
  <div class="edit-form-list-item">
    <div class="history-item">
      <div class="history-item-button">
        <div class="button">
          <el-button :disabled="!(index > 0 && length > 1)" icon="el-icon-arrow-up" circle
            @click.stop="handleCommand('moveUp')"></el-button>
        </div>
        <div class="button">
          <el-button :disabled="!(index + 1 != length && length > 1)" icon="el-icon-arrow-down" circle
            @click.stop="handleCommand('moveDown')"></el-button>
        </div>
      </div>
      <div class="history-item-content">
        <el-form class="history-form" ref="historyItemForm" :model="item" :rules="rules" @submit.native.prevent>

          <el-form-item prop="title" class="edit-form-item">
            <div class="item-name"><label for="title">タイトル</label></div>
            <el-input class="input-lg" type="textbox" id="title" :autosize="{ minRows: 1, maxRows: 4 }"
              :placeholder="'アピールしたいプロダクト等のタイトルを入力'" v-model="item.title" ref="desc"></el-input>
          </el-form-item>

          <el-form-item prop="tools" class="edit-form-item">
            <div class="item-name"><label for="tools">使用ツール・言語等</label></div>
            <el-input class="input-lg" type="textbox" id="tools" :autosize="{ minRows: 1, maxRows: 4 }"
              :placeholder="'使用したツールや言語等を入力'" v-model="item.tools" ref="desc"></el-input>
          </el-form-item>

          <el-form-item prop="description" class="edit-form-item">
            <div class="item-name"><label for="description">説明文</label></div>
            <el-input type="textarea" id="description" :autosize="{ minRows: 3, maxRows: 4 }"
              :placeholder="'説明を入力'" v-model="item.description" ref="desc"></el-input>
          </el-form-item>
          <br><br>

          <el-form-item prop="mainImage" class="edit-form-item">
            <div class="item-name"><label for="mainImage">メイン画像</label></div>
            <div class="image-upload-container" @click="handleImageUpload('main')">
              <input type="file" ref="mainImageInput" class="image-input" accept="image/*"
                @change="onImageSelected($event, 'main')" style="display: none">
              <div class="upload-placeholder" v-if="!item.mainImage">
                <i class="el-icon-picture"></i>
                <p>写真をアップロード</p>
              </div>
              <div v-else class="image-container">
                <img :src="item.mainImage" class="preview-image">
                <div class="delete-button" @click.stop="deleteImage('main')">
                  <i class="el-icon-close"></i>
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item prop="subImage" class="edit-form-item">
            <div class="item-name"><label for="subImage">サブ画像</label></div>
            <div class="sub-images-container">
              <div v-for="n in 5" :key="n" class="image-upload-container sub-image-item" @click="$globalVar.isYagiPrime ? handleImageUpload(`sub${n}`) : $eventHub.$emit('show-yagiprime-register-dialog-from-image-item')">
                <input type="file" :ref="`sub${n}ImageInput`" class="image-input" accept="image/*"
                  @change="onImageSelected($event, `sub${n}`)" style="display: none">
                <div class="upload-placeholder" v-if="!item[`subImage${n}`]">
                  <p class="lock-icon" v-if="!$globalVar.isYagiPrime">🔒️</p>
                  <i class="el-icon-picture" v-else></i>
                  <p>写真を<br class="sp">アップロード</p>
                </div>
                <div v-else class="image-container">
                  <img :src="item[`subImage${n}`]" class="preview-image">
                  <div class="delete-button" @click.stop="deleteImage(`sub${n}`)">
                    <i class="el-icon-close"></i>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- :class="{ 'detail__visible': this.activeHistoryItem != this.item.uuid}" -->
    <div class="projects" :class="{ 'project__invisible': isActive() == false }">
      <div class="add-project-item enter">
        <el-button icon="el-icon-delete" @click.stop="handleCommand('delete')">削除</el-button>
        <el-button icon="el-icon-check" @click.stop="$eventHub.$emit('deactivate-image-item')">OK</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    length: {
      type: Number
    },
    descriptionPlaceholder: {
      type: String
    },
    descriptionMaxLength: {
      type: Number
    },
    minYear: {
      type: [Number, String]
    },
    maxYear: {
      type: [Number, String]
    },
    activeImageItem: {
      type: String
    }
  },
  data: function () {
    const app = this
    const validateYear = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > 6) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    const validateMonth = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > 4) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    const validateDescription = function (rule, value, callback) {
      if (app.$formLib.charCount(value) > app.descriptionMaxLength) {
        callback(new Error('Please input digits'))
      }
      callback()
    }
    return {
      errors: [],
      rules: {
        year: [
          {
            validator: validateYear,
            message: '年が長すぎます',
            trigger: ['change', 'blur']
          }
        ],
        month: [
          {
            validator: validateMonth,
            message: '月が長すぎます',
            trigger: ['change', 'blur']
          }
        ],
        description: [
          {
            validator: validateDescription,
            message: '一行におさまる文字数をオーバーしています。文章を短くするか、行を ＋ で追加して入力してください。',
            trigger: ['change', 'blur']
          }
        ]
      }
    }
  },
  computed: {
    computedMinYear: function () {
      if (this.minYear) {
        return Number(this.minYear)
      }
      return 1980
    },
    computedMaxYear: function () {
      if (this.maxYear) {
        return Number(this.maxYear)
      }
      return new Date().getFullYear()
    }
  },
  methods: {
    handleCommand: function (command) {
      if (command === 'addAbove') {
        this.$emit('add-history-item', this.index)
      } else if (command === 'addBelow') {
        this.$emit('add-history-item', this.index + 1)
      } else if (command === 'delete') {
        this.$emit('delete-history-item', this.index)
      } else if (command === 'duplicate') {
        this.$emit('add-history-item', this.index, this.item)
      } else if (command === 'moveUp') {
        this.$emit('move-history-item', {
          index: this.index,
          to: 'up'
        })
      } else if (command === 'moveDown') {
        this.$emit('move-history-item', {
          index: this.index,
          to: 'down'
        })
      } else if (command === 'addProject') {
        this.$emit('add-project-history-item', this.index, this.item)
      }
    },
    isActive: function () {
      if (this.activeImageItem === this.item.uuid) {
        return true
      } else {
        return false
      }
    },
    activateItem: function (id) {
      console.log(id)
    },
    deleteDetail: function (index2) {
      this.$emit('delete-history-item-detail', this.index, index2)
    },
    moveUpDetail: function (index2) {
      this.$emit('move-history-item-detail', {
        index: index2,
        to: 'up'
      }
      , this.index)
    },
    moveDownDetail: function (index2) {
      this.$emit('move-history-item-detail', {
        index: index2,
        to: 'down'
      }
      , this.index)
    },
    resizeDesc: function () {
      const app = this
      this.$nextTick(function () {
        if (typeof app.$refs.desc.resizeTextarea === 'function') {
          if (app.$refs.desc.$el.offsetHeight) {
            app.$refs.desc.resizeTextarea()
          }
        }
      })
    },
    changeCheckbox: function () {
      if (this.item.isContinuing) {
        this.item.endYear = ''
        this.item.endMonth = ''
      }
    },
    handleImageUpload (type) {
      if (type === 'main') {
        this.$refs[`${type}ImageInput`].click()
      } else {
        // サブ画像の場合は配列の最初の要素を使用
        const refArray = this.$refs[`${type}ImageInput`]
        if (refArray && refArray[0]) {
          refArray[0].click()
        }
      }
    },
    onImageSelected (event, type) {
      const file = event.target.files[0]
      if (file) {
        // 即座に読み込み中の状態を通知
        if (type === 'main') {
          this.$set(this.item, 'mainImage', null)
          this.$emit('image-loading', { index: this.index, type: 'main' })
        } else if (type.startsWith('sub')) {
          const n = type.replace('sub', '')
          this.$set(this.item, `subImage${n}`, null)
          this.$emit('image-loading', { index: this.index, type: `sub${n}` })
        }

        const reader = new FileReader()
        reader.onload = (e) => {
          if (type === 'main') {
            this.$set(this.item, 'mainImage', e.target.result)
            this.$nextTick(() => {
              this.$emit('image-updated', { index: this.index, type: 'main', value: e.target.result })
            })
          } else if (type.startsWith('sub')) {
            const n = type.replace('sub', '')
            this.$set(this.item, `subImage${n}`, e.target.result)
            this.$nextTick(() => {
              this.$emit('image-updated', { index: this.index, type: `sub${n}`, value: e.target.result })
            })
          }
          this.$emit('image-loaded', { index: this.index, type })
        }
        reader.readAsDataURL(file)
      }
    },
    deleteImage (type) {
      if (type === 'main') {
        this.$set(this.item, 'mainImage', null)
        this.$emit('image-updated', { index: this.index, type: 'main', value: null })
      } else if (type.startsWith('sub')) {
        const n = type.replace('sub', '')
        this.$set(this.item, `subImage${n}`, null)
        this.$emit('image-updated', { index: this.index, type: `sub${n}`, value: null })
      }
    }
  },
  beforeMount: function () {
    this.$nextTick(function () {
      // 初回読み込み時にバリデーションを動かす
      this.$refs.historyItemForm.validate().then().catch(function (e) {
        // console.error(e)
      })
    })
  },
  mounted: function () {
    this.$eventHub.$on('card-changed', this.resizeDesc)
  },
  destroyed: function () {
    this.$eventHub.$off('card-changed', this.resizeDesc)
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/variables";

$white: #fff;
$basecolor: #f8f8f8;
$light-gray: #dcdfe6;
$errorcolor: #f56c6c;

/* .projects { */
/* background-color:rgba(246,247,249,0.8); */
/* } */
.project__invisible {
  display: none;
}

.project__invisible2 {
  display: none;
}

.edit-form-list-item {
  &.active {
    .project-item {
      border-top: dashed 1px $light-gray;
      padding: 1rem 0;

      .enter {
        margin-top: .5rem;
      }
    }
  }
}

.history-item {
  display: flex;
  flex-direction: row-reverse;
}

.history-item-content {
  flex: 1;
  margin: .5rem 0;
  padding: .5rem 1rem;

  .attention-limit {
    font-size: .75rem;
    color: $errorcolor;

    &.character {
      padding: .5rem 0;
    }

    &.column {
      background: $white;
      margin: .5rem 0;
      padding: .5rem 1rem;
    }
  }
}

/* 詳細を隠す時に上下ボタンが高さを確保してしまうので修正 */
/* buttonにdisplay: flex; 追加 */
.history-item-button {
  .button {
    display: flex;
  }
}

.projects {
  margin-top: .5rem;

  >ul {
    list-style: none;
    // list-style-position: inside;
    font-size: .75rem;

    li {
      &::before {
        content: "";
        display: inline-block;
        background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OTYgNDk2Ij48Zz48cGF0aCBkPSJNMjQ4LDBDMTExLDAsMCwxMTEsMCwyNDhTMTExLDQ5NiwyNDgsNDk2LDQ5NiwzODUsNDk2LDI0OCwzODUsMCwyNDgsMFpNNDAzLjMxLDE5NS4zMWwtMTg0LDE4NGgwYTE2LDE2LDAsMCwxLTIyLjYyLDBsLTEwNC0xMDRhMTYsMTYsMCwwLDEsMC0yMi42MmwyMi42Mi0yMi42M2ExNiwxNiwwLDAsMSwyMi42MywwTDIwOCwzMDAuMTIsMzU4LjA2LDE1MC4wNmExNiwxNiwwLDAsMSwyMi42MywwbDIyLjYyLDIyLjYzQTE2LDE2LDAsMCwxLDQwMy4zMSwxOTUuMzFaIi8+PC9nPjwvc3ZnPg==");
        margin-right: .25rem;
        width: .75rem;
        height: .75rem;
      }
    }
  }

  /* background-color: $basecolor; */
}

.project-item {
  display: flex;
  flex-direction: row-reverse;
  /* background: #f2f2f2; */
}

.project-item-button {
  display: flex;
  flex-direction: column;
  width: 3.5rem;

  // border-bottom: solid 1px darken($basecolor, 5);
  .button {
    flex: 1;

    button {
      height: 100%;
      border-radius: 0;
      border: none;

      &.is-disabled {
        color: darken($basecolor, 5);
      }
    }
  }
}

.project-item-content {
  flex: 1;
  margin: .5rem 0;
  padding: .5rem 1rem;

  .attention-limit {
    font-size: .75rem;
    color: $errorcolor;

    &.character {
      padding: .5rem 0;
    }

    &.column {
      background: $white;
      margin: .5rem 0;
      padding: .5rem 1rem;
    }
  }
}

.add-project-item {
  border-top: dashed 1px $light-gray;
  padding: 1rem;
  text-align: right;
}

.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.image-upload-container {
  width: 100%;
  height: 200px;
  border: 2px dashed #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.3s;
  position: relative;

  &:hover {
    border-color: #0F9934;
  }
}

.upload-placeholder {
  text-align: center;
  color: #909399;

  .lock-icon {
    font-size: 2rem;
  }

  i {
    font-size: 32px;
    margin-bottom: 8px;
  }

  p {
    margin: 0;
    font-size: 14px;
  }
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.sub-images-container {
  display: flex;
  gap: 10px;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-bottom: 10px;

  @include max-width(sm){
    flex-wrap: wrap;
  }

}

.sub-image-item {
  //flex: 0 0 200px;
  height: 150px;

  @include max-width(sm){
    width: calc(50% - 5px);
    height: 100px;
  }
}

.image-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-button {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  opacity: 0;
  transition: opacity 0.2s;
  z-index: 10;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }

  i {
    font-size: 16px;
  }
}

.image-container:hover .delete-button {
  opacity: 1;
}
</style>
